module.exports = __webpack_public_path__ + "9521a7f3c264cb4482ed4b563fbd59cd.pdf";